/** Estado compartido de contadores en vivo (Soporte). Evita dependencias circulares Dashboard ↔ uiHandlers. */

export const ticketExecutionTimers = new Map();
export const ticketOpenTimers = new Map();

export const PERSISTED_EXEC_TIMER_PREFIX = 'dashboard_ticket_exec_timer_v2:';
export const PERSISTED_OPEN_TIMER_PREFIX = 'dashboard_ticket_open_timer_v2:';

const safeLocalStorageRemove = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    // ignore
  }
};

/** Detiene el contador de tiempo de ejecución en memoria y en localStorage (p. ej. al completar el ticket). */
export function clearTicketExecutionTimer(ticketId) {
  const id = String(ticketId);
  ticketExecutionTimers.delete(id);
  safeLocalStorageRemove(`${PERSISTED_EXEC_TIMER_PREFIX}${id}`);
}
